/**
 * Theme option
 *
 * These options are used in the settings screen when the user tries to change their theme.
 */
export enum ThemeOption {
  /**
   * Dark
   */
  Dark = 'dark',
  /**
   * Light
   */
  Light = 'light',
  /**
   * System theme (auto)
   */
  System = 'system',
}
